module.exports = __webpack_public_path__ + "img/help.01dffa31.svg";